import React from 'react';
import PropTypes from 'prop-types';
import { useConnect } from '@lore/query-connect';
import ConnectButton from './ConnectButton';
import { PayloadStates } from '@lore/utils';
import Wrapper from './Wrapper';
import useDialogLauncher from '@hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '@/dialogs_new/DialogManager';

ProjectBanner.propTypes = {
  user: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired
};

export default function ProjectBanner(props) {
  const {
    user,
    project
  } = props;

  const launch = useDialogLauncher();

  const creator = useConnect('user.byId', {
    id: project.data.creatorId
  });

  const questions = useConnect('question.find', {
    where: {
      eager: {
        $where: {
          userId: user.id,
          projectId: project.id,
          request: { $not: 'Outreach' }
        }
      }
    },
    include: function(model) {
      return (
        model.data.userId === user.id &&
        model.data.projectId === project.id &&
        model.data.request !== 'Outreach'
      );
    }
  });

  function showInviteDialog() {
    launch(DialogManager.QuestionInvite.Config(project.id, user.id));
  }

  if (questions.state === PayloadStates.FETCHING) {
    return (
      <Wrapper user={user} creator={creator}>
        <ConnectButton disabled={true}>
          ...
        </ConnectButton>
      </Wrapper>
    );
  }

  // if (user.id === currentUser.id) {
  //   return (
  //     <Wrapper user={user}>
  //       <ConnectButton disabled={true}>
  //         This is you
  //       </ConnectButton>
  //     </Wrapper>
  //   );
  // }

  if (questions.data.length > 0) {
    return (
      <Wrapper user={user} creator={creator}>
        <ConnectButton disabled={true}>
          Connected
        </ConnectButton>
      </Wrapper>
    );
  }

  return (
    <Wrapper user={user} creator={creator}>
      <ConnectButton onClick={showInviteDialog}>
        Connect
      </ConnectButton>
    </Wrapper>
  );
};
